<template>
  <!-- <div id="webreader-app" class="webreader-app" @click="closeNavigations($event)"> -->
    <!-- Main heading for the webreader, visually hidden but accessible for screen readers -->
    <h1 class="announce" id="main-app-heading">{{ $t('cci_main_heading') }}</h1>
    <div tabindex="0" role="link" class="skip-link" id="skip-to-main-link" @click.prevent="skipToMainContent" @keydown.enter="skipToMainContent">{{ $t('cci_skip_link_main') }}</div>
    <cci-navigation-bar v-if="!isVerticalLayout"></cci-navigation-bar>
    <cci-right-aligned-navigation-bar v-if="showRightAlignedBar"></cci-right-aligned-navigation-bar>
    <cci-sections-bar v-if="showSectionsBar && !isVerticalLayout"></cci-sections-bar>
    <cci-google-ad-side v-if="showGptAdModuleSide"></cci-google-ad-side>
    <cci-google-ad-bottom-mobile v-if="showGptAdModuleBottom"></cci-google-ad-bottom-mobile>
    <router-view></router-view>
    <cci-issue-overview v-if="showIssueOverview"></cci-issue-overview>
    <cci-article-modal v-if="showArticleModal"></cci-article-modal>
    <cci-social-sharing :shareObj="pageChildObj()" v-if="showSharing" @close="$store.commit('setShowSharing', false)"></cci-social-sharing>
    <cci-scrubber v-if="showScrubber"></cci-scrubber>
    <cci-image-gallery-modal :displayObj="pageChildObj()" v-if="showImageGalleryModal"></cci-image-gallery-modal>
    <cci-left-aligned-scrubber v-if="showLeftAlignedScrubber && $route.name === 'pages'"></cci-left-aligned-scrubber>
  <!-- </div> -->
</template>

<script src="./WebreaderApp.js"></script>

<style lang=scss>
@import 'helpers/_colors-and-mixins.scss';
@import 'base/_common-styles.scss';
@import '~nprogress/nprogress.css';

#webreader-app {
  -webkit-overflow-scrolling: touch;
  position: relative;
  height: 100%;
  
  /* from common styles of body */
  background-color: rgb(229,229,229);
  font-family: 'Open Sans', sans-serif;
  font-size: 14px;
  background-color: rgb(229,229,229);
  color:#1f1f1f;
  text-rendering: optimizeLegibility;
  -webkit-font-smoothing: antialiased;
  overflow: hidden;
}

button {
  border: none;
  background-color: unset;
}

figure {
  margin: 0;
}

* {
  box-sizing: border-box;
}
*:before,
*:after {
  box-sizing: border-box;
}


#nprogress .bar {
  background: white;
  z-index: 10000;
  height: 4px;
}

#nprogress .spinner {
  z-index: 10000;
}

#nprogress .spinner-icon {
  border: solid 3px transparent;
  border-top-color: white;
  border-left-color: white;
  width: 20px;
  height: 20px;
}

#nprogress .peg {
  display: none;
}

.skip-link {
  position: absolute;
  top: 10px;
  left: 10px;
  background: white;
  color: $wet-asphalt;
  padding: 12px;
  z-index: -10000;
  line-height: 1;
  border-radius: 4px;
  cursor: pointer;
  opacity: 0;
  transition: opacity 0.2s ease-in-out;
  /* text-decoration: underline; */
}

.skip-link:focus {
  /* top: 0; */
  z-index: 20000;
  opacity: 1;
  outline: 3px solid $wet-asphalt;
  box-shadow: 0 0 6px rgba(0, 0, 0, 0.5);
}

.announce {
  position: absolute;
  width: 1px;
  height: 1px;
  margin: -1px;
  padding: 0;
  border: 0;
  overflow: hidden;
  clip: rect(0 0 0 0);
  white-space: nowrap; /* Prevent line breaks */
}

</style>
